import moment from "moment";
import ausPhone from "./aus-phone";


function resolveAction(account, service, handlerAction) {

    // Check parameters to prevent run-time errors
    account = account || {};
    service = service || {};
    // If we don't have an handler action object use the service's action
    if (typeof(handlerAction) === 'undefined') {
        handlerAction = service.action || {};
    }

    // Set up our action type data sources
    let contacts    = account.contacts    || [];
    let dialActions = account.dialActions || [];
    let greetings   = account.greetings   || [];
    let voicemails  = account.voicemails  || [];
    let schedules   = service.schedules   || [];
    let voiceMenus  = service.voiceMenus  || [];

    //console.log('account', account);
    //console.log('service', service);

    let type = handlerAction.type;
    let id   = handlerAction.id;
    let action;
    let detail = {name: '', text: '', longText: ''};

    if (type === 'schedule') {
        // Special case for 'schedule' type because we need the actual action dictated by the schedule
        let schedule = findAction([schedules], id);

        action = findAction([dialActions, voicemails, greetings, voiceMenus], currentAction(schedule).id);
        if (action === null) {
            action = {type: 'reject'};
        }

    } else {
        if (type === 'reject') {
            action = {id: null, name:"Reject All Calls"};
        } else {
            action = findAction([dialActions, voicemails, greetings, voiceMenus], id);
        }
    }

    // Build an object with the number dialed, plus a description eg.
    // { longText: 'Calls are forwarded to xx,x...', name: 'Dial Chanel', text: '0412 236 548' }
    // { longText: 'Calls will be sent to After Hours Voicemail', name: 'After Hours Voicemail', text: 'After Hours Voicemail' }
    // { longText: 'Calls will be sent to Voice Menu', name: 'Voice Menu', text: 'Voice Menu' }
    // { longText: 'Callers hear Office Closed', name: 'Office Closed', text: 'office-closed-monday.mp3' }
    //console.log('detail=',detail);
    detail.name = action.name;

    switch (action.type || 'reject') {
        case 'dial':
            detail.text     = dialActionNumbers(action);
            detail.longText = 'Calls are forwarded to ' + action.name;
            break;

        case 'voicemail':
        case 'ivr':
            detail.text     = action.name;
            detail.longText = 'Calls will be sent to ' + action.name;
            break;

        case 'say':
            detail.text     = action.name;
            detail.longText = 'Callers hear ' + action.name;
            break;

        case 'play':
            detail.text     = action.file.name;
            detail.longText = 'Callers hear ' + action.name;
            break;

        case 'reject':
            detail.text     = 'rejected';
            detail.longText = 'Calls are rejected immediately';
            break;

        default:
            detail.text     = '';
            detail.longText = '';
    }

    return detail;


    /***
     * findAction returns the action with the passed ID from the
     * passed array of action arrays.
     *
     * @param actions
     * @param id
     * @returns {*}
     */
    function findAction(actions, id) {
        for (let i=0; i < actions.length; i++) {
            for (let j=0; j < actions[i].length; j++) {
                if (actions[i][j].id === id) {
                    return actions[i][j];
                }
            }
        }
        return null;
    }

    function currentAction(schedule) {
        //console.log('currentAction', schedule);
        let now = moment();                                 // moment from current date/time
        let idx = now.day() - 1;                            // day is 0-6  => Sunday - Monday
        if (idx === -1) {
            idx = 6
        }                          // Sunday is at index 6
        let minutes = now.hours() * 60 + now.minutes();       // current time in minutes
        if (minutes >= schedule.schedule[idx].start &&
            minutes < schedule.schedule[idx].finish && schedule.schedule[idx].checked) {
            return schedule.action;                         // return the work hours action
        } else {
            return schedule.ahAction;                       // return the after hours action
        }
    }

    function dialActionNumbers(dialAction) {
        let numbers = [];
        for (let i=0; i < dialAction.contacts.length; i++) {
            for (let j=0; j < contacts.length; j++) {
                if (dialAction.contacts[i] === contacts[j].id) {
                    // If the contact's number is a SIP address, use the contact name
                    if (contacts[j].number.startsWith('sip')) {
                        numbers.push( contacts[j].name )
                    } else {
                        numbers.push( ausPhone(contacts[j].number) );
                    }
                    break;
                }
            }
        }
        let sep = ', ';
        if (dialAction.dialType === 'simulring') {
            sep = ' + ';
        }
        return numbers.join(sep);
    }
}

export default resolveAction;